/* requires:
polyfill.js
*/

// Dropdown Select Toggle
const activeClass = 'is-active';
const dropdownCollection = document.querySelectorAll('.dropdown-list span.dropdown');
for (let dropdownToggle of dropdownCollection) {
  dropdownToggle.addEventListener('click', function () {
    //console.log(dropdownToggle.classList);
    if (!dropdownToggle.classList.contains(activeClass)) {
      const el = document.querySelectorAll('.dropdown-list span.dropdown');
      for (let i = 0; i < el.length; i++) {
        el[i].classList.remove(activeClass);
      }
      dropdownToggle.classList.toggle(activeClass);
    } else if (dropdownToggle.classList.contains(activeClass)) {
      dropdownToggle.classList.remove(activeClass);
    }
  });
}

document.addEventListener(
  'click',
  function (e) {
    // Dropdown Select Toggle
    const el = document.querySelectorAll('.dropdown-list span.dropdown');
    const eventElement = e.target;
    if (!eventElement.closest('.dropdown-list')) {
      //console.log(event_element.closest(".dropdown-list"));
      for (let i = 0; i < el.length; i++) {
        el[i].classList.remove(activeClass);
      }
    }
  },
  false
);
